import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link as RouterLink, useLocation, useHistory } from 'react-router-dom'
import {
  AppBar,
  Box,
  Link,
  Toolbar,
  Typography,
  Divider,
  Slide,
  useScrollTrigger
} from '@material-ui/core'
import { scroller } from 'react-scroll'
import Logo from 'src/assets/images/ufc/logo-lsbd.svg'
import LoginDropdown from 'src/components/LoginDropdown/LoginDropdown'
import { Language, navLinks } from 'src/types/global'
import { maxMobileScreenWidth } from 'src/utils/breakpoints'
import NavbarMobile from 'src/components/Mobile/Navbar/NavbarMobile'
import useMedia from 'src/hooks/useMedia'
import { useStyles } from './Navbar.styles'

const Navbar = () => {
  const { t, i18n } = useTranslation()
  const location = useLocation()
  const history = useHistory()
  const classes = useStyles()
  const [languageOption, setLanguageOption] = useState<Language>('pt')
  const getOptionClass = (lang: Language) =>
    `${classes.option} ${languageOption === lang ? classes.activeOption : ''}`

  const handleChangeLanguage = (lang: Language) => {
    setLanguageOption(lang)
    i18n.changeLanguage(lang).then()
  }

  const { width } = useMedia()

  const [isOpen, setIsOpen] = useState<boolean>(false)
  const toggleSidebar = () => {
    setIsOpen(!isOpen)
  }
  const trigger = useScrollTrigger()

  useEffect(() => {
    setLanguageOption(i18n.language === 'pt' ? 'pt' : 'en')
  }, [i18n.language])

  const handleContactClick = () => {
    if (location.pathname !== '/') {
      history.push({
        pathname: '/',
        state: { scrollTo: 'contact' }
      })
    } else {
      scroller.scrollTo('contact', {
        smooth: true,
        duration: 1000
      })
    }
    toggleSidebar()
  }

  return (
    <>
      {width <= maxMobileScreenWidth ? (
        <NavbarMobile isOpen={isOpen} toggle={toggleSidebar} />
      ) : (
        <Slide appear={false} direction="down" in={!trigger}>
          <AppBar position="fixed" className={classes.appBar}>
            <Toolbar className={classes.toolBar}>
              <Link component={RouterLink} to="/" underline="none">
                <img src={Logo} alt="logo lsbd" className={classes.logo} />
              </Link>
              <Box className={classes.box}>
                {navLinks.map(({ to, label }) => (
                  <Link
                    key={to}
                    component={RouterLink}
                    to={to}
                    underline="none"
                  >
                    <Typography
                      variant="h6"
                      className={classes.linkText}
                      color="textPrimary"
                    >
                      {t(label)}
                    </Typography>
                  </Link>
                ))}
                <Link
                  onClick={handleContactClick}
                  style={{ cursor: 'pointer' }}
                  underline="none"
                >
                  <Typography
                    variant="h6"
                    className={classes.linkText}
                    color="textPrimary"
                  >
                    {t('navbar.contact')}
                  </Typography>
                </Link>
                <Box className={classes.boxOptionsLanguage}>
                  <Typography
                    className={getOptionClass('pt')}
                    onClick={() => handleChangeLanguage('pt')}
                    variant="h6"
                  >
                    PT
                  </Typography>
                  <Divider
                    orientation="vertical"
                    className={classes.divider}
                    flexItem
                  />
                  <Typography
                    className={getOptionClass('en')}
                    onClick={() => handleChangeLanguage('en')}
                    variant="h6"
                  >
                    EN
                  </Typography>
                </Box>
                <LoginDropdown />
              </Box>
            </Toolbar>
          </AppBar>
        </Slide>
      )}
    </>
  )
}

export default Navbar
